const actions = {
    FETCH_STUDENTS : 'FETCH_STUDENTS',
    FETCH_NEW_STUDENTS : 'FETCH_NEW_STUDENTS',
    FETCH_STUDENT  : 'FETCH_STUDENT',
    RESET_STUDENT  : 'RESET_STUDENT',

    // NEW ACTION TYPES FOR SUBJECTIVE ATTENDANCE
    FETCH_STUDENT_SUBJECTS: 'FETCH_STUDENT_SUBJECTS',
    FETCH_STUDENT_SUBJECTIVE_ATTENDANCE: 'FETCH_STUDENT_SUBJECTIVE_ATTENDANCE',
    FETCH_STUDENT_ATTENDANCE: 'FETCH_STUDENT_ATTENDANCE',
    FETCH_STUDENT_ATTENDANCE_METRICS: 'FETCH_STUDENT_ATTENDANCE_METRICS',
    FETCH_STUDENT_SUBJECTIVE_ATTENDANCE_METRICS: 'FETCH_STUDENT_SUBJECTIVE_ATTENDANCE_METRICS',

    fetchStudentsAction: (data) => {
        return {
            type: actions.FETCH_STUDENTS,
            data: data
        };
    },
    fetchNewStudentsAction: (data) => {
        return {
            type: actions.FETCH_NEW_STUDENTS,
            data: data
        };
    },
    resetStudentFormAction: () => {
        return {
            type: actions.RESET_STUDENT,
            data: null
        };
    },
    fetchStudentAction: (data) => {
        return {
            type: actions.FETCH_STUDENT,
            data: data
        };
    },

    // NEW ACTION CREATORS FOR SUBJECTIVE ATTENDANCE
    fetchStudentSubjectsAction: (data) => {
        return {
            type: actions.FETCH_STUDENT_SUBJECTS,
            data: data
        };
    },
    fetchStudentSubjectiveAttendanceAction: (data) => {
        return {
            type: actions.FETCH_STUDENT_SUBJECTIVE_ATTENDANCE,
            data: data
        };
    },
    fetchStudentAttendanceAction: (data) => ({
        type: actions.FETCH_STUDENT_ATTENDANCE,
        data: data
    }),
    fetchStudentAttendanceMetricsAction: (data) => {
        return {
            type: actions.FETCH_STUDENT_ATTENDANCE_METRICS,
            data: data
        };
    },
    fetchStudentSubjectiveAttendanceMetricsAction: (data) => {
        return {
            type: actions.FETCH_STUDENT_SUBJECTIVE_ATTENDANCE_METRICS,
            data: data
        };
    },
}

export default actions;